/**
 * @generated SignedSource<<5f06960ac93487a807492793a80297f7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type AssistantMode = "aiStory" | "assistant" | "cardDetail" | "letsPractise" | "listenVocab" | "speaking" | "%future added value";
export type grammarFeedbackQuery$variables = {
  context?: string | null;
  language?: string | null;
  mode?: AssistantMode | null;
  text: string;
};
export type grammarFeedbackQuery$data = {
  readonly grammarFeedback: {
    readonly correctedText: string | null;
    readonly detectedLanguage: string | null;
    readonly score: number | null;
  };
};
export type grammarFeedbackQuery = {
  response: grammarFeedbackQuery$data;
  variables: grammarFeedbackQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "context"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "language"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "mode"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "text"
},
v4 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "context",
        "variableName": "context"
      },
      {
        "kind": "Variable",
        "name": "language",
        "variableName": "language"
      },
      {
        "kind": "Variable",
        "name": "mode",
        "variableName": "mode"
      },
      {
        "kind": "Variable",
        "name": "text",
        "variableName": "text"
      }
    ],
    "concreteType": "GrammarFeedbackResponse",
    "kind": "LinkedField",
    "name": "grammarFeedback",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "correctedText",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "score",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "detectedLanguage",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "grammarFeedbackQuery",
    "selections": (v4/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "grammarFeedbackQuery",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "ad4fbe57fa8f563e8cf2556953f0e26c",
    "id": null,
    "metadata": {},
    "name": "grammarFeedbackQuery",
    "operationKind": "query",
    "text": "query grammarFeedbackQuery(\n  $text: String!\n  $context: String\n  $language: String\n  $mode: AssistantMode\n) {\n  grammarFeedback(text: $text, context: $context, language: $language, mode: $mode) {\n    correctedText\n    score\n    detectedLanguage\n  }\n}\n"
  }
};
})();

(node as any).hash = "5ef18490fc5f35f37e8e3535bb5651e6";

export default node;
